<template>
    <div class="max-width-content">
        <trashed-message v-if="sitepage.deleted_at" class="mb-6" @restore="restore">
           Deze sitepagina is verwijderd.
        </trashed-message>

        <breadcrumbs>
            <inertia-link :href="route('admin.sitepages.index')">Sitepaginas</inertia-link>
            <i class="fad fa-chevron-right"></i>
            <inertia-link :href="route('admin.sitepages.show', sitepage.id)">{{ sitepage.title | truncate(35) }}</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Wijzig
        </breadcrumbs>

        <div class="mt-5 bg-white rounded-lg px-8 py-5">
            <site-page-form :sitepage="sitepage" :categories="categories" @submit="submit" :data-loading="loading"></site-page-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import SitePageForm from "@/admin/Pages/SitePages/SitePageForm";

export default {
    metaInfo() {
        return { title: this.sitepage.title };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        TrashedMessage,
        Breadcrumbs,
        SitePageForm
    },

    mixins: [Helpers],

    props: {
        sitepage: Object,
        categories: Array
    },

    data() {
        return {};
    },

    methods: {
        submit(data) {
            this.loading = "submit";

            const url = this.route("admin.sitepages.update", this.sitepage.id).url();
            data.append("_method", "patch");
            const options = { onFinish: () => this.loading = false}

            this.$inertia.post(url, data, options)
        }
    }
};
</script>
